import React, { useState,useContext } from "react";
import Pagination from "../../components/pageProps/shopPage/Pagination";
import Banner from "../../components/Banner/Banner";
import { UserConfigContext } from "../../context/UserConfigContext";

const News = () => {

  return (
    <div className="max-w-container mx-auto">
      <div className="pb-10">
      <h1 className="text-4xl font-bold mt-6 mb-4">Novedades</h1>
    
      <Pagination />
      </div>
    </div>
  );
};

export default News;
